// extracted by mini-css-extract-plugin
export var csatScore = "_fo-5";
export var header = "_fo-1";
export var panelWrapper = "_fo-2";
export var postPreview = "_fo-3";
export var rightContent = "_fo-0";
export var wrappingText = "_fo-4";